import { useSession } from '@side/next-auth/react';
import { useCallback } from 'react';
import { coreApi } from '$api-clients';
import {
  isListingEligibleForOfferMatch,
  STATUS_INCLUSION_FACET,
} from './useMatchingListings';

export const useMatchListingByMls = () => {
  const agentId = useSession()?.data?.user?.id;

  return useCallback(
    async (
      mlsVendor: string,
      mlsNumber: string,
    ): Promise<string | undefined> => {
      if (!agentId || !mlsVendor || !mlsNumber) return undefined;

      const { data, error } = await coreApi.GET('/listings', {
        params: {
          query: {
            facets: `agentId:${agentId},isArchived:false,${STATUS_INCLUSION_FACET},mlsNumber:${mlsNumber},mlsId:${mlsVendor}`,
            sort: 'createdAt:desc',
            limit: 20,
          },
        },
      });
      if (error !== undefined) {
        throw new Error(typeof error === 'string' ? error : error.message);
      }
      for (const listing of data.results) {
        if (isListingEligibleForOfferMatch(listing)) {
          return listing.id;
        }
      }
      return undefined;
    },
    [agentId],
  );
};
